<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import { convertValue, extractMeta } from '../../utilities/utils';
import LeakWidget from '../../widgets/Leak';
import { computed } from 'vue';
import type { PropType } from 'vue';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const temp = computed(() => props.viewValues.values.find((v) => v.type === 'temp'));
const humidity = computed(() => props.viewValues.values.find((v) => v.type === 'analog'));
const leak = computed(() => props.viewValues.values.find((v) => v.type === 'switch'));

const params = computed(() => ({
  temp: convertValue(temp.value),
  humidity: convertValue(humidity.value),
  leak: convertValue(leak.value),
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <LeakWidget v-bind="params" />
</template>
